import { ModelBase } from 'store/model-base';

export class CmsLevelMoveEligibility extends ModelBase {
    public static storeName: string = 'cmsLevelMoveEligibility';

    public header: string;
    public subhead: string;
    public pageTitle: string;
    public icon: CmsMediaImage;
}
